import { createRootRoute, Outlet, useSearch } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import React from 'react';
import { BreakpointProvider } from '#src/hooks/breakpoint-provider';
import { useBlockElementId } from '#src/hooks/use-block-element';
import { StateMachineContext } from '#src/state-machine/context';
import { DrupalSettings } from '#src/utils/drupal-settings/read-drupal-settings';
import { parseUrlToContext } from '#src/utils/url-sync-xstate';

function Root() {
  const search = useSearch({ strict: false });
  const blockElementId = useBlockElementId();

  // Parse URL search parameters to context overrides
  const urlContext = React.useMemo(() => {
    return parseUrlToContext(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const settings = React.useMemo(() => {
    return DrupalSettings.getDashboardFiltersSettings(blockElementId);
  }, [blockElementId]);

  return (
    <>
      <BreakpointProvider>
        <StateMachineContext.Provider
          options={{
            input: { urlContext, settings },
          }}
        >
          <div className='app-container'>
            <Outlet />
          </div>
        </StateMachineContext.Provider>
      </BreakpointProvider>
      {import.meta.env.NODE_ENV === 'development' && <TanStackRouterDevtools />}
    </>
  );
}

export const Route = createRootRoute({
  component: Root,
});
